const productSlider = document.querySelectorAll('[data-slider="product-slider"]');

const productSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  freeMode: true,
  speed: 800,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 'auto',
      spaceBetween: 16,
    },
    1024: {
      spaceBetween: 20,
      freeMode: false,
      slidesPerGroup: 2,
    },
  },
};

const initProductSlider = (scope = document) => {
  const productSlider = scope.querySelectorAll('[data-slider="product-slider"]');
  productSlider.forEach((el) => {
    if (el.swiper) {
      return;
    }
    const productSliderParent = el.closest('.product-slider');
    const arrowRight = productSliderParent.querySelector('.arrow-right');
    const arrowLeft = productSliderParent.querySelector('.arrow-left');
    const scrollbar = productSliderParent.querySelector('.swiper-scrollbar');

    productSliderOptions.navigation.nextEl = arrowRight;
    productSliderOptions.navigation.prevEl = arrowLeft;
    productSliderOptions.scrollbar.el = scrollbar;

    const fixedSlides = productSliderParent.classList.contains('product-slider--fixed-two-slides');

    let sliderBreakpoints = { ...productSliderOptions.breakpoints };

    if (fixedSlides) {
      sliderBreakpoints = {
        767: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1023: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      };
    }

    if (windowWidth() > 767) {
      new Swiper(el, { ...productSliderOptions, breakpoints: sliderBreakpoints });
    } else {
      enableScrollbarSync(productSliderParent);
    }
  });
};

initProductSlider();

setupResponsiveSliders({
  sliderElements: productSlider,
  breakpoint: 767,
  initSlider: initProductSlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});
